module.exports = __webpack_public_path__ + "static/media/book_fantasy_spine.2c48ef98.png";